import MeetingsCardView from './MeetingsCardView'

export default MeetingsCardView
